
import { TIMEOUT_SECONDS } from "./config.js";


function timeout(s) {
    return new Promise(function (_, reject) {
        setTimeout(function () {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};


function fetchRequest(url, data) {
    return !data ? fetch(url) : fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    });
}


export const ajax = async function(url = "", data = "") {
    try {
        const request = await Promise.race([fetchRequest(url, data), timeout(TIMEOUT_SECONDS)]);
        const response = await request.json();

        if (!request.ok && request.status === 400) {
            throw new Error(`${request.statusText} --> ${response.message}`);
        }

        return response;
    } catch(error) {
        throw error;
    }
}